
import React from 'react';
import { Input } from '@/components/ui/input';

interface FormFieldProps {
  id: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  icon: React.ReactNode;
  label: string;
  rightIcon?: React.ReactNode;
  onClick?: () => void;
}

export const FormField = ({
  id,
  type,
  placeholder,
  value,
  onChange,
  onKeyDown,
  icon,
  label,
  rightIcon,
  onClick
}: FormFieldProps) => {
  return (
    <div className="space-y-3">
      <label htmlFor={id} className="text-sm font-medium flex items-center text-gray-700 dark:text-gray-300">
        {icon}
        {label}
      </label>
      <div className="relative">
        <Input
          id={id}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          className="border border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-gray-800/50 backdrop-blur-sm focus:border-youtube-red focus:ring-youtube-red transition-all duration-300 pl-4"
        />
        {rightIcon && (
          <button
            type="button"
            onClick={onClick}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-youtube-red transition-colors duration-300"
          >
            {rightIcon}
          </button>
        )}
      </div>
    </div>
  );
};
